import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo_2.png";
import moonIcon from "../../assets/images/moon.svg";
import settingsIcon from "../../assets/images/settings.svg";
import bellIcon from "../../assets/images/bell.svg";
import sendLikeIcon from "../../assets/images/send_like_icon.svg";
import likedIcon from "../../assets/images/liked_icon.png";
import matchesIcon from "../../assets/images/mymatches_icon.svg";
import searchIcon from "../../assets/images/search_icon.svg";
import userIcon from "../../assets/images/user_icon.svg";
import love_diamond from "../../assets/images/love_diamond.png";

import { useUserStore } from "../../store/useUserStore";
import useAuthStore from "../../store/useAuthStore";
import useSignOut from 'react-auth-kit/hooks/useSignOut';
import { Modal } from 'react-bootstrap';
import Notifications from "../Notifications";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import axiosInstance from "../../api/axiosInstance";
import { useSubscriptionStore } from "../../store/useSubscriptionStore";
import { toast } from "react-toastify";
const MySwal = withReactContent(Swal);


const WSurl = import.meta.env.VITE_APP_WS_URL;

const DashboardHeader: React.FC = () => {
  const {logout } = useAuthStore();
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [likeModal, setLikeModal] = useState(false);
  const [matchModal, setMatchModal] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
 

  const shownRequestIds = useRef(new Set());
  const shownMatchFlag = useRef(false); // use flag for match

  const authStore = useAuthStore.getState();
  const { paymentDetails, getSubscription } = useSubscriptionStore();
  const {newRequest, getNewRequests ,updateOnlineStatus } = useUserStore();
  const location = useLocation();
  const navigate = useNavigate();
  const signOut = useSignOut();
  const userId = authStore.user?.id;
  const isActive = (path: string) => (location.pathname.startsWith(path)  ? "active" : "");
  console.log(location.pathname.startsWith("/messages"));
  console.log(isActive("/messages"));

useEffect(() => {
  const onMessagesPage = location.pathname.startsWith("/messages");


 

  if (!userId) return;
  getSubscription(userId);

  if (!userId || onMessagesPage) {
    // ✅ Don't open notification socket when on chat page
    return;
  }

  const client = new WebSocket(`${WSurl}${userId}?type=notification`);

  client.onopen = () => console.log("WebSocket notification connected.");
  client.onclose = () => console.log("WebSocket notification closed.");
  client.onmessage = async event => {
    const data = JSON.parse(event.data);
    console.log("Received notification:", data);

    const showNotification = async () => {
      if ("Notification" in window && Notification.permission === "granted") {
        try {
          // 🔹 Check if service worker is supported (mobile Chrome path)
          if ("serviceWorker" in navigator) {
            const reg = await navigator.serviceWorker.getRegistration();
            if (reg) {
              return reg.showNotification(`New message from ${data.first_name}`, {
                body: data.message,
                icon: data.pic || "/default-avatar.png",
              });
            }
          }

          // 🔹 Desktop fallback
          new Notification(`New message from ${data.first_name}`, {
            body: data.message,
            icon: data.pic || "/default-avatar.png",
          });
        } catch (err) {
          console.error("Notification error:", err);
          toast(`New message from ${data.first_name}`);
        }
      } else {
        toast(`New message from ${data.first_name}`);
      }
    };

    // ✅ Only show notification if not already on messages page
    if (!onMessagesPage) {
      showNotification();
    }
  };

  return () => client.close();
}, [location.pathname]);




useEffect(() => {
  const setupPush = async () => {
    if (!("Notification" in window) || !("serviceWorker" in navigator) || !("PushManager" in window)) {
      console.log("❌ Push notifications not supported");
     // alert("❌ Push notifications not supported Notification"+ ("Notification" in window));
     // alert("❌ Push notifications not supported serviceWorker"+ ("serviceWorker" in navigator));
    //  alert("❌ Push notifications not supported PushManager"+ ("PushManager" in window));
      return;
    }

     // Ask for notification permission if needed
  if ("Notification" in window) {
    if (Notification.permission !== "granted") {
      Notification.requestPermission().then(async permission => {

           try {
              const reg = await navigator.serviceWorker.ready;

              const subscription = await reg.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array("BMIWTr5q0HCeVjwfddzDCi0J8VHJXhZNlEm_QCn1r-zw46gwgJbIrvVbBwB0HyIGSolZFQdGvzAbOTtdgOcrOOE"),
              });

              console.log("✅ Push subscription:", subscription);

              await axiosInstance.post("/save-subscription", {
                userId,
                subscription,
              });
            } catch (err) {
              console.error("❌ Failed to subscribe to push:", err);
              if (err instanceof Error) {
                console.log("❌ Push subscription failed: " + err.message);
              } else {
                 console.log("❌ Push subscription failed: " + String(err));
              }
              //alert("❌ Push subscription failed: " + JSON.stringify(err));
            }
        if (permission !== "granted") {
          console.log("Notifications blocked by user.");
        }
      });
    }
  } else {
    console.log("Notifications are not supported on this device/browser.");
  }


   try {
      const reg = await navigator.serviceWorker.ready;

      const subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array("BMIWTr5q0HCeVjwfddzDCi0J8VHJXhZNlEm_QCn1r-zw46gwgJbIrvVbBwB0HyIGSolZFQdGvzAbOTtdgOcrOOE"),
      });

      console.log("✅ Push subscription:", subscription);

      await axiosInstance.post("/save-subscription", {
        userId,
        subscription,
      });
    } catch (err) {
      console.error("❌ Failed to subscribe to push:", err);
      if (err instanceof Error) {
       // alert("❌ Push subscription failed: " + err.message);
      } else {
      //  alert("❌ Push subscription failed: " + String(err));
      }
      //alert("❌ Push subscription failed: " + JSON.stringify(err));
    }
 
  };

  setupPush();

}, [userId]);

// const askPermission = async () => {
//   try {
//     const permission = await Notification.requestPermission();
//    // alert("Permission result: " + permission);

//     if (permission !== "granted") {
//       console.log("❌ Notifications blocked by user");
//      // alert("❌ Notifications blocked by user");
//       //return;
//     }

//     console.log("✅ Notifications allowed");
//    // alert("✅ Notifications allowed");
//   } catch (err) {
//     console.error("Error requesting permission:", err);
//     //alert("Error: " + (err instanceof Error ? err.message : String(err)));
//   }
// };

// Helper
function urlBase64ToUint8Array(base64String: string) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}




useEffect(() => {
  const interval = setInterval(async () => {
    updateOnlineStatus(authStore.user?.id);

    const nereq = await getNewRequests(authStore.user?.id);

    // ✅ Handle LIKE Modal (loop for first unshown request)
    const firstUnseen = nereq?.newRequests?.find((req:any) => !shownRequestIds.current.has(req.id));
    
    if (nereq?.newRequestCount > 0 && firstUnseen) {
      setLikeModal(true);
      shownRequestIds.current.add(firstUnseen.id); // ✅ Mark this request as shown
    } else {
     // setLikeModal(false);
    }

    // ✅ Handle MATCH Modal (simple flag)
    if (nereq?.matchedCount > 0 && !shownMatchFlag.current) {
      setMatchModal(true);
      shownMatchFlag.current = true;
    } else {
     // setMatchModal(false);
    }

  }, 2000);

  return () => clearInterval(interval);
}, [authStore.user?.id]);


  useEffect(() => {
       console.log('Payment details found:', paymentDetails);
    if (paymentDetails != null && paymentDetails.trial_end != null && (paymentDetails.transaction_id == '' || paymentDetails.transaction_id == null)) {
      console.log('Payment details found:', paymentDetails.trial_end );
      check7daytrial();
    }
  }, [paymentDetails]);



  useEffect(() => {
 



   
    const navbar = document.getElementById("navbarNav");

    const handleShow = () => setMenuOpen(true);
    const handleHide = () => setMenuOpen(false);

    if (navbar) {
      navbar.addEventListener("shown.bs.collapse", handleShow);
      navbar.addEventListener("hidden.bs.collapse", handleHide);
    }

    return () => {
      if (navbar) {
        navbar.removeEventListener("shown.bs.collapse", handleShow);
        navbar.removeEventListener("hidden.bs.collapse", handleHide);
      }
    };


  }, []);
  const handleLogout =()=>{
    logout();
    signOut();
    navigate('/');
  }

const getDayDifference = (date1: any, date2: any) => {
  const d1 = new Date(date1).setHours(0, 0, 0, 0);
  const d2 = new Date(date2).setHours(0, 0, 0, 0);
  return Math.ceil((d1 - d2) / (1000 * 60 * 60 * 24));
};

const isNotToday = (date: any) => {
  const today = new Date();
  const input = new Date(date);
  return (
    today.getFullYear() !== input.getFullYear() ||
    today.getMonth() !== input.getMonth() ||
    today.getDate() !== input.getDate()
  );
};

  const check7daytrial = async () => {
  const idx = userId;

  try {
    const res = await axiosInstance.post('updatetrialpopup', {
      id: idx,
      update: false,
    });

    if (res.status === 200) {
      const dateToCheck = res.data.popupStatus;
      const notToday = isNotToday(dateToCheck);

      if (notToday) {
        const trialEndDate = new Date(res.data.trial_end);
        const currentDate = new Date();
        const daysLeft = getDayDifference(trialEndDate, currentDate);

        if (daysLeft > 0 && daysLeft <= 7) {
          await axiosInstance.post('updatetrialpopup', {
            id: idx,
            update: true,
          });

          // Use React-based modal
          MySwal.fire({
            html: (
              <div className="text-center">
                <h4 className="mb-3 text-primary">Trial Expiring Soon</h4>
                <p>
                  Your free trial, with unrestricted access to all features,
                  is expiring in <strong>{daysLeft} day{daysLeft === 1 ? '' : 's'}</strong>.
                  <br />
                  Please choose a plan within this period to continue enjoying our services.
                </p>
                <div className="d-flex justify-content-center gap-2 mt-4">
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      navigate('/settings#subscription');
                      MySwal.close();
                    }}
                  >
                    Choose Plan Now
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={() => MySwal.close()}
                  >
                    Decide Later
                  </button>
                </div>
              </div>
            ),
            showConfirmButton: false,
            showCloseButton: true,
            customClass: {
              popup: 'bg-light p-4 rounded',
              closeButton: 'btn-close position-absolute top-0 end-0 m-3',
            },
          });
        } else if (
          trialEndDate.setHours(0, 0, 0, 0) < currentDate.setHours(0, 0, 0, 0) &&
          res.data.status == 1
        ) {
          navigate('/settings#subscription');
        }
      }
    }
  } catch (e) {
    console.error(e);
  }
};




  return (
    <>
    <header className="user_dashboard_header">
      <nav className="navbar navbar-expand-lg navbar-light bg-primary">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src={logo} alt="Logo" className="img-fluid" />
          </Link>
          {/* Mobile Bell Icon */}
          <div className="mobile-bell-icon d-lg-none">
            <Link 
              className="nav-link" 
              to="#" 
              onClick={() => setShowNotifications(true)}
            >
              <span className="nav_icon_box">
                {newRequest.notificationsCount > 0 && <span className="notifcn_active"></span>}
                <img src={bellIcon} alt="Notifications" />
              </span>
            </Link>
          </div>
          <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded={menuOpen ? "true" : "false"}
          aria-label="Toggle navigation"
        >
          {menuOpen ? <i className="fa-solid fa-times"></i> : <span className="navbar-toggler-icon"></span>}
        </button>
          <div className="collapse navbar-collapse customNav" id="navbarNav">

                {/* 🚀 MOBILE MENU — ONLY VISIBLE ON MOBILE */}
                <div className="mobile-nav d-lg-none pb-2">

                  {/* TOP ROW: Zodiac (left) and Settings (right) */}
                  <div className="mobile-top-row">
                    {/* LEFT → Zodiac */}
                    <div className="left-item">
                      <Link className={`nav-link ${isActive("/zodiac")}`} to="/zodiac">
                        <span className="nav_icon_box">
                          <img src={moonIcon} alt="Zodiac" />
                        </span>
                        Zodiac
                      </Link>
                    </div>

                    {/* RIGHT → Settings Dropdown */}
                    <div className="right-item dropdown">
                      <Link
                        className={`nav-link dropdown-toggle ${isActive("/settings")}`}
                        to="#"
                        id="mobileSettingsDropdown"
                        role="button"
                        data-bs-toggle="dropdown"
                        onClick={() => setDropdownOpen(!dropdownOpen)}
                      >
                        <span className="nav_icon_box">
                          <img src={settingsIcon} alt="Settings" />
                        </span>
                        Settings
                      </Link>

                      <ul className={`dropdown-menu ${dropdownOpen ? "show" : ""}`}>
                        <li><button className="dropdown-item" onClick={() => navigate('/settings')}>Manage Account</button></li>
                        <li><button className="dropdown-item" onClick={() => navigate('/help')}>Help</button></li>
                        <li><button className="dropdown-item" onClick={() => handleLogout()}>Logout</button></li>
                      </ul>
                    </div>
                  </div>

                  {/* MOBILE UPGRADE BUTTON */}
                  {paymentDetails?.status == 1 ? null : (
                    <Link to="/settings#subscription" className="btn btn-dark w-100 mt-3">
                      Upgrade
                    </Link>
                  )}

                </div>
                {/* END MOBILE NAV */}

                {/* 🚀 DESKTOP MENU — ONLY VISIBLE ON DESKTOP */}
                <div className="desktop-nav d-none d-lg-flex ms-auto abovemenu user_dashboard_right_menu">

                  {/* Desktop Zodiac */}
                  <Link className={`nav-link me-3 ${isActive("/zodiac")}`} to="/zodiac">
                    <span className="nav_icon_box me-2">
                      <img src={moonIcon} alt="Zodiac" />
                    </span>
                    Zodiac
                  </Link>

                  <span className="text-white me-3">|</span>

                  {/* Desktop Settings */}
                  <div className="nav-item dropdown">
                    <Link
                      className={`nav-link dropdown-toggle me-3 ${isActive("/settings")}`}
                      to="#"
                      id="desktopSettingsDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      onClick={() => setDropdownOpen(!dropdownOpen)}
                    >
                      <span className="nav_icon_box me-2">
                        <img src={settingsIcon} alt="Settings" />
                      </span>
                      Settings
                    </Link>

                    <ul className={`dropdown-menu ${dropdownOpen ? "show" : ""}`}>
                      <li><button className="dropdown-item" onClick={() => navigate('/settings')}>Manage Account</button></li>
                      <li><button className="dropdown-item" onClick={() => navigate('/help')}>Help</button></li>
                      <li><button className="dropdown-item" onClick={() => handleLogout()}>Logout</button></li>
                    </ul>
                  </div>

                  {/* Desktop Bell */}
                  <div className="desktop-bell">
                    <Link className={`nav-link me-3 ${showNotifications ? "active" : ""}`} to="#" onClick={() => setShowNotifications(true)}>
                      <span className="nav_icon_box">
                        {newRequest.notificationsCount > 0 && <span className="notifcn_active"></span>}
                        <img src={bellIcon} alt="Notifications" />
                      </span>
                    </Link>
                  </div>

                  {/* Desktop Upgrade */}
                  {paymentDetails?.status == 1 ? null : (
                    <Link to="/settings#subscription" className="btn btn-dark">Upgrade</Link>
                  )}

                </div>
                {/* END DESKTOP NAV */}

              </div>
        </div>
      </nav>




      <div className="user_dashboard_header_bottom">
        <div className="container">
          <div className="user_dashboard_header_bottom_menu">
            <Link className={`nav-link ${isActive("/dashboard")}`} to="/dashboard">
              <img src={sendLikeIcon} alt="Send Likes" />
              Send Likes
            </Link>
            <Link className={`nav-link ${isActive("/liked")}`} to="/liked">
              <img src={likedIcon} alt="Liked You" />
              Liked You
              {newRequest.newRequestCount >0 ?<span className="badge text-bg-secondary">{newRequest?.newRequestCount}</span> : ''}
            </Link>
            <Link className={`nav-link ${isActive("/matched")}`}  to="/matched">
              <img src={matchesIcon} alt="My Matches" />
              My Matches
              {newRequest.matchedCount >0 ?<span className="badge text-bg-secondary">{newRequest?.matchedCount}</span> : ''}
     
            </Link>
            <Link className={`nav-link ${isActive("/search")}`} to="/search">
              <img src={searchIcon} alt="Search" />
              Search
            </Link>
            <Link className={`nav-link ${isActive("/myprofile")}`} to="/myprofile">
              <img src={userIcon} alt="My Profile" />
              My Profile
            </Link>
          </div>
        </div>
      </div>

      
      {/* <div className="bottom-nav">
        <Link className={`bottom-nav-item ${isActive("/dashboard")}`} to="/dashboard">
          <img src={sendLikeIcon} alt="Send Likes" />
          <span>Send Likes</span>
        </Link>
        <Link className={`bottom-nav-item ${isActive("/liked")}`} to="/liked">
          <img src={likedIcon} alt="Liked You" />
          <span>Liked You</span>
        </Link>
        <Link className={`bottom-nav-item ${isActive("/matched")}`} to="/matched">
          <img src={matchesIcon} alt="My Matches" />
          <span>My Matches</span>
        </Link>
        <Link className={`bottom-nav-item ${isActive("/search")}`} to="/search">
          <img src={searchIcon} alt="Search" />
          <span>Search</span>
        </Link>
        <Link className={`bottom-nav-item ${isActive("/myprofile")}`} to="/myprofile">
          <img src={userIcon} alt="My Profile" />
          <span>My Profile</span>
        </Link>
      </div> */}
    </header>

    <Modal show={likeModal}  centered>
    <div className="modal-dialog-centered">
            <div className="modal-content bg-light">
                <div className="modal-header border-0">
                    <button onClick={()=>setLikeModal(false)} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body text-center pb-4 px-4">
                    <img src={newRequest?.newRequests[0]?.user.id == userId ? 
                      (newRequest?.newRequests[0]?.user_photos_to[0]?.picture || newRequest?.newRequests[0]?.user_to.pic) : 
                      (newRequest?.newRequests[0]?.user_photos[0]?.picture ||  newRequest?.newRequests[0]?.user.pic)} alt="" className={`round-img dp_user_img mb-3 ${newRequest?.newRequests[0]?.user.id} - ${userId}` } />
                    <h3>You've Got a New Like</h3>
                    <p>Someone is interested in you. View their profile to see if you feel the same way. </p>
                    <button type="button" className="btn btn-primary" onClick={()=>{setLikeModal(false);
                      navigate('/liked')}}>See who</button>
                </div>
    
            </div>
        </div>
      
    </Modal>

    <Modal show={matchModal}  centered>
     
        <div className="modal-dialog-centered">
            <div className="modal-content bg-light">
                <div className="modal-header border-0">
                    <button onClick={()=>{setMatchModal(false);
                      }} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body text-center py-5 px-4">
                    <img src={love_diamond} alt="" className="dp_user_img mb-3" />
                    <h3>🎉 It's a Match! 🎉</h3>
                    <p>Start exploring your connection with the Love Diamond, where you can express your interest. Make
                        the first move and send a message!</p>
                    <button type="button" className="btn btn-primary py-2" onClick={()=>{setMatchModal(false);
                      navigate('/matched')}}>Start Chatting</button>
                </div>

            </div>
        </div>
      </Modal>

    
      <Notifications
          show={showNotifications}
          handleClose={() => setShowNotifications(false)}
          userId={userId}
        />
        </>
  );
};

export default DashboardHeader;
